import React from "react";
import { WeekDays } from "config";
import { Checkbox } from "../Checkbox";
import { CheckboxColor, WeekDay } from "store/types/enum";
import { formatWeekDayToShortString } from "utils/weekDayUtil";

interface WeekDayCheckboxGroupProps {
  checked: Array<WeekDay>;
  onChange: (_: Array<WeekDay>) => void;
  checkboxColor?: CheckboxColor;
}

export const WeekDayCheckboxGroup: React.FC<WeekDayCheckboxGroupProps> = ({
  onChange,
  checked,
  checkboxColor = CheckboxColor.Gray,
}) => {
  return (
    <div className="flex gap-4">
      {WeekDays.map((day, idx) => (
        <div key={idx} className="flex gap-1.5 cursor-pointer">
          <Checkbox
            name={"weekday" + day}
            checked={checked.includes(day)}
            onChange={() => {
              if (checked.includes(day)) {
                onChange(checked.filter((d) => d !== day));
              } else {
                onChange([...checked, day]);
              }
            }}
            checkboxColor={checkboxColor}
          />
          <label className="cursor-pointer">{formatWeekDayToShortString(day)}</label>
        </div>
      ))}
    </div>
  );
};
